//@flow
//$FlowFixMe
import React, { useState } from 'react'
import { connect } from 'react-redux'
import { Button, useInput } from 'sputnik-ui'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Slide,
  Tab,
  Tabs,
  TextField,
} from '@material-ui/core'

import { expenseBilling } from '../../../store/companies/operations'

const Transition = props => <Slide direction="up" {...props} />

const PAYMENT_TYPES = [
  { label: 'ВЭД-Ошибочное пополнение', value: 'ved_erroneous_deposit' },
  { label: 'ВЭД-Перенос на другой личный кабинет', value: 'ved_transfer_to_another_account' },
  { label: 'ВЭД-Списание за услуги - увеличение УПД на сумму услуг', value: 'ved_service_charge' },
  { label: 'Ошибочное пополнение - сумма УПД не меняется', value: 'erroneous_deposit' },
  { label: 'Перенос на другой личный кабинет - сумма УПД не меняется', value: 'transfer_to_another_account' },
  { label: 'Списание за услуги - увеличение УПД на сумму услуг', value: 'service_charge' },
]

const ReassignIntercomModal = ({
  open,
  selectedCompany,
  sendingMoney,
  handleClose,
  dispatch,
}: Props) => {
  const { value: amount, bind: bindAmount } = useInput('')
  const { value: comment, bind: bindComment } = useInput('')
  const { value: virtual, setValue: setVirtual } = useInput(false)
  const [accountType, setAccountType] = useState('invoice')
  const [paymentType, setPaymentType] = useState('')

  const handleTabChange = (_, newValue) => {
    setVirtual(newValue === 0)
    setPaymentType('')
  }

  const handleSubmit = e => {
    e.preventDefault()
    dispatch(expenseBilling({ amount, comment, virtual, accountType, paymentType, companyUuid: selectedCompany })).then(
      () => {
        handleClose()
      },
    )
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      TransitionComponent={Transition}
      PaperProps={{ style: styles.dialogWindow }}
      onExit={() => {}}
    >
      <DialogTitle>Списать денег</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent style={{ overflow: 'visible', paddingTop: 0 }}>
          <FormControl fullWidth style={{ marginBottom: '.325rem' }}>
            <InputLabel>Основание операции</InputLabel>
            <Select value={paymentType} onChange={e => setPaymentType(e.target.value)}>
              {PAYMENT_TYPES.map(type => (
                <MenuItem key={type.value} value={type.value}>{type.label}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            label="Cумма"
            {...bindAmount}
            autoFocus
            fullWidth
            style={{ marginBottom: '.325rem' }}
          />
          <TextField label="Комментарий" {...bindComment} fullWidth />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            secondary
            rounded
            size="small"
            tabIndex={-1}
          >
            закрыть
          </Button>
          <Button
            rounded
            primary
            size="small"
            onClick={handleSubmit}
            disabled={!amount || !paymentType || sendingMoney}
            type="submit"
          >
            Списать{sendingMoney && '...'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  )
}

type MS = {
  selectedCompany: string,
  sendingMoney: boolean,
}

type Props = {
  open: boolean,
  handleClose: Function,
  dispatch: Function,
} & MS

const styles = {
  dialogWindow: { overflow: 'visible', minWidth: 418 },
}

const mapStateToProps = ({ companies }): MS => ({
  selectedCompany: companies.selected && companies.selected.value,
  sendingMoney: companies.sendingMoney,
})


export default connect(mapStateToProps)(ReassignIntercomModal)
